import { Form } from "../Abstracts/Form";
import { EntityModalForm } from "../CRUDs/abstracts/mixins/EntityModalForm";
import { CRUDFabric } from "../CRUDs/CRUDFabric";
import { Preloader } from "../Common/Preloader";
import { Signature } from "../Common/Signature";
import { checkoutVerification } from "./checkoutVerification";


export class PaymentForm extends Form {

    targetFormId = ''
    targetType = ''
    invoice

    constructor(invoice, type = 'payment') {

        super('select_pm-modal', `${invoice.urlRoot}/${invoice.id}/pay`, 'POST');
        this.targetFormId = `${type}-${invoice.entityClass}-modal`
        this.targetType = type

        this.formInfo = document.querySelector(`#${this.targetFormId}`);
        this.invoice = invoice;
        this.submitBtn = this.form.querySelector(`#confirm-payment-invoice`);
        this.listners();
        this.formInfo.setAttribute('data-form_type', invoice.entityClass);

        this.preloader = new Preloader('select_pm-modal', true);
        this.preloader.close();

        const hasSignature = document.querySelector('#signature-container #signature');
        this.getSignatureData = Signature.init(hasSignature, { width: 396, height: 190 });

        PaymentForm.prototype.collectData = function () {
            const paymentData = {
                method: this.form.querySelector('input#payment_method_type').value,
                target_id: this.form.querySelector('input#payment_method_id').value,
                signature: this.getSignatureData()
            }
            return paymentData;
        }

        checkoutVerification.setReturnScript(PaymentForm.verificationReturnScript(invoice.id, invoice.getClass()));
        checkoutVerification.setCheckSignatureCb(this.checkEmptySignature.bind(this))
    }

    static verificationReturnScript(id, constructor) {
        return function () {
            const options = {
                selected_pm: $('#selected_pm').val(),
            };
            const invoice = new constructor(id);
            invoice.openModal(this.targetType, options);
            const form = new PaymentForm(invoice);
            form.payConfirm();
        }
    }

    payConfirm() {
        $(`#${this.targetFormId}`).modal('hide');
        $('.modal-backdrop').first().remove();
        $(`#select_pm-modal`).modal('show');
    }

    showMissingPaymentMethodsMessage() {
        $('#payment-invoice-modal').modal('hide');
        $('#no-payment-method').modal('show');
    }

    checkEmptySignature() {
        const data = this.getSignatureData();
        $('#signature-empty-error').addClass('d-none')
        if (data === false) {
            $('#signature-empty-error').removeClass('d-none')
            setTimeout(() => {
                $('#signature-empty-error').addClass('d-none')
            }, 3000)
            return false
        } else {
            return data
        }
    }

    async submit() {
        const data = this.collectData();
        const is_paid = { is_paid: $('input#selected_method').val() };
        let final_data = Object.assign(is_paid, data);
        if (!this.checkEmptySignature())
            return
        let preloaderMessage;
        if (data.method == "card") preloaderMessage = "Wait until payment will be approved";
        if (data.method == "bank_account") preloaderMessage = "Wait until bank is checking your account";

        this.preloader.setMessage(preloaderMessage);
        this.preloader.open();

        const result = $.ajax({
            type: this.method,
            url: this.actionUrl,
            data: final_data,
            success: this.successCallback.bind(this),
            error: this.errorCallback.bind(this),
        });
    }

    async successCallback(response) {
        if (response?.stripe_secret) {
            checkoutVerification.checkoutVerification(response);
        } else {
            const formHTML = response.modal;
            EntityModalForm.pasteForm(formHTML);
            $('.modal-backdrop').first().remove();
            $('#success_payment-modal').modal('show');
            let payServiceBtn = $(`.pay-service-invoice[data-payment_id=${this.invoice.id}]`)
            if (payServiceBtn.length)
                payServiceBtn.remove()
        }
    }

    async errorCallback(response) {
        const resultMessage = response.responseJSON;
        const formHTML = resultMessage.modal;
        EntityModalForm.pasteForm(formHTML);
        $('.modal-backdrop').first().remove();
        $('#failed_payment-modal').modal('show');
    }

    listners() {
        super.listners();

        let paymentMethodsCount = $('.payment-method-select .payment-method-row').length;

        if (paymentMethodsCount > 0) {
            this.formInfo.querySelector('#pay').addEventListener('click', this.payConfirm);
        } else {
            this.formInfo.querySelector('#pay').addEventListener('click', this.showMissingPaymentMethodsMessage);
        }

        $(this.form).find('.form-control.payment-method-select').on('click', this.openCloseSelect);
        $(this.form).find('.payment-method-row').on('click', this.selectPaymentMethod.bind(this));

        this.selectPaymentMethod();
    }

    selectPaymentMethod(e) {

        const paymentMethod = e?.currentTarget ? $(e.currentTarget) : this.getPrimariPaymentMethod();
        const selectedMethodContainer = $('.selected-payment-method .payment-method-wrapper');
        const inputTypeElement = $('input#payment_method_type');
        const inputIdElement = $('input#payment_method_id');

        $('#payment-method-select .select-container').find('.payment-method-wrapper').removeClass('selected');
        paymentMethod.addClass('selected');

        selectedMethodContainer.html(paymentMethod.html());
        inputTypeElement.val(paymentMethod.data('type'));
        inputIdElement.val(paymentMethod.data('id'));

        this.showHideVerificationMessage(paymentMethod);
    }

    /**
     * Отображение или скрытие блока с выбором верификации банковского аккаунта
     *
     * @param {*} paymentMethod
     */
    showHideVerificationMessage(paymentMethod) {
        if (paymentMethod[0] && paymentMethod[0].hasAttribute('data-verification-required') && (paymentMethod.data('id') !== parseInt($('input#selected_method').val()))) {
            this.updateDataForInstantlyVerification();
            $('#confirm-actions-group').removeClass('d-flex').addClass('d-none');
            $('span.mannually_verification-start').data('id', paymentMethod.data('id')).removeClass('d-none');
            $('#start-checkout-verification').data('id', paymentMethod.data('id')).removeClass('d-none');
            $('.agreement').addClass('d-none');
            $('.verification-required.agreement').removeClass('d-none').addClass('d-flex');
            $('#selected_pm').val(paymentMethod.data('id'));
        } else {
            $('#confirm-actions-group').removeClass('d-none').addClass('d-flex');
            $('span.mannually_verification-start').addClass('d-none');
            $('button#start-checkout-verification').addClass('d-none');
            $('.agreement').removeClass('d-none');
            $('.verification-required.agreement').addClass('d-none').removeClass('d-flex');
            $('#selected_pm').val('');
        }
    }

    /**
     * Назначение функции - добавление данных для проведения платежа и верфикации одним действием
     */
    updateDataForInstantlyVerification() { 
        const entity = $(`#${this.targetFormId}`).data('entity')
        if(!entity)
            throw new Error('Payment form must have attr "data-entity"')
        let options = {}, total = '0.50';
        options = {
            entity,
            entity_id: $(`#${this.targetFormId} #entity_id`).val(),
        };
        total = $(`#${this.targetFormId} #total-value`).data('total');
        $('#start-checkout-verification').data('options', JSON.stringify(options));
        $('.v_payment_amount').text(total);
    }

    openCloseSelect() {
        const selectContainer = document.querySelector('.payment-method-select .select-container');

        if (selectContainer.classList.contains('closed')) selectContainer.classList.remove('closed');
        else selectContainer.classList.add('closed');
    }

    getPrimariPaymentMethod() {
        const inputTypeElement = $('input#payment_method_type');
        const inputIdElement = $('input#payment_method_id');
        const selectedMethodId = $('input#selected_method');

        if (inputTypeElement.val() && inputIdElement.val() && !selectedMethodId.val()) {
            return $(`.payment-method-wrapper[data-type=${inputTypeElement.val()}][data-id=${inputIdElement.val()}]`);
        } else if (selectedMethodId.val()) {
            return $(`.payment-method-wrapper[data-type="bank_account"][data-id=${selectedMethodId.val()}]`);
        } else {
            return $('.payment-method-row').first();
        }
    }
}



